import component from './SpreadForm.vue'
export default component
